import { useSelector } from "react-redux";

export function useSalesTokenCompaniesLogic(){
    const model = useSelector(state => state.site.model)

    const getCompaniesForSalesToken = (sitePath) => {
        const orgs = model.organizations.filter(org => org.sitePath.startsWith(sitePath))

        return orgs
    }

    return {
        getCompaniesForSalesToken
    }
}